import { render, staticRenderFns } from "./Handicap.vue?vue&type=template&id=04e7345a&scoped=true"
import script from "./Handicap.vue?vue&type=script&lang=js"
export * from "./Handicap.vue?vue&type=script&lang=js"
import style0 from "./Handicap.vue?vue&type=style&index=0&id=04e7345a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7345a",
  null
  
)

export default component.exports